import {graphql, compose} from 'react-apollo';
import gql from 'graphql-tag';
import {Device, LogUser} from '../qql-shared/fragments';
import {SaveUserMutation, SaveUserMutationConfig} from '../qql-shared/mutations';
import Logs from "../components/Logs";

const UserQuery = gql`
  query user($_id:String!) {
    user(_id:$_id) {
      ...LogUser
    }
  }
  ${LogUser}
`;

const reduceToLookupTable = devices =>
  devices.reduce((lookupTable, device) => {
    lookupTable[device._id] = device;
    return lookupTable;
  }, {});

const UserQueryConfig = {
  options: ({match}) => ({variables: {_id: match.params.id}, fetchPolicy: 'cache-and-network'}),
  props({data: {user, ...data}, ...rest}) {
    let convertedUser = user;
    if (user) {
      const {devices, logs} = user;
      const lookupTable = reduceToLookupTable(devices);
      const convertedLogs = logs.map(log => ({...log, device: lookupTable[log.deviceId]}));
      convertedUser = {...user, logs: convertedLogs};
    }
    return {...rest, data: {...data, user: convertedUser}};
  }
};

const ToggleDeviceBlockingMutation = gql`
  mutation toggleDeviceBlocking($_id: String!, $deviceId: String!) {
    toggleDeviceBlocking(
      _id: $_id
      deviceId: $deviceId
    ) {
      ...Device
    }
  }
  ${Device}
`;

const ToggleDeviceBlockingMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    toggleDeviceBlocking: deviceId => mutate({variables: {_id, deviceId}})
  })
};

export default compose(
  graphql(SaveUserMutation, SaveUserMutationConfig),
  graphql(ToggleDeviceBlockingMutation, ToggleDeviceBlockingMutationConfig),
  graphql(UserQuery, UserQueryConfig)
)(Logs);



// WEBPACK FOOTER //
// ./src/containers/UserLogs.js